// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DatapointsEntityTypeFromJSON, DatapointsEntityTypeToJSON, } from './';
export function DatapointsRequestBaseFromJSON(json) {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'entityId': json['entityId'],
        'entityType': DatapointsEntityTypeFromJSON(json['entityType']),
        'asOfDate': new Date(json['asOfDate']),
        'dashboardOptions': !exists(json, 'dashboardOptions') ? undefined : json['dashboardOptions'],
        'startDate': !exists(json, 'startDate') ? undefined : new Date(json['startDate']),
        'filterCashflows': !exists(json, 'filterCashflows') ? undefined : json['filterCashflows'],
    };
}
export function DatapointsRequestBaseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'entityId': value.entityId,
        'entityType': DatapointsEntityTypeToJSON(value.entityType),
        'asOfDate': value.asOfDate.toISOString(),
        'dashboardOptions': value.dashboardOptions,
        'startDate': value.startDate === undefined ? undefined : value.startDate.toISOString(),
        'filterCashflows': value.filterCashflows,
    };
}
